(() => {
  // app/scripts/localization-form.js
  if (!customElements.get("localization-form")) {
    customElements.define("localization-form", class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
        this.detailsContainer = this.querySelector("details");
        this.summaryToggle = this.querySelector("summary");
        this.panel = this.summaryToggle.nextElementSibling;
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
        this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
      }
      onContainerKeyUp(event) {
        event.preventDefault();
        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (this.summaryToggle.getAttribute("aria-expanded") == "false")
              return;
            this.hidePanel();
            event.stopPropagation();
            break;
          case "SPACE":
            if (this.summaryToggle.getAttribute("aria-expanded") == "true")
              return;
            this.summaryToggle.click();
            break;
        }
      }
      onContainerKeyDown(event) {
      }
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.input.value = event.currentTarget.dataset.value;
        if (form)
          form.submit();
      }
      onSummaryClick(e) {
        this.summaryToggle.setAttribute("aria-expanded", (this.summaryToggle.getAttribute("aria-expanded") === "false").toString());
      }
      onFocusOut(event) {
        if (!this.contains(event.target) || !this.contains(event.relatedTarget)) {
          this.hidePanel();
        }
      }
      hidePanel() {
        this.detailsContainer.removeAttribute("open");
        this.summaryToggle.setAttribute("aria-expanded", "false");
      }
    });
  }
})();
